// src/utils/authUtils.ts

import firebase from 'firebase/compat/app';

import { auth } from '../firebase/firebase';

// Sign in anonymously and return the user ID
export const signInAnonymously = async (): Promise<string> => {
    try {
        // First check if user is already signed in
        let currentUser = auth.currentUser;

        if (!currentUser) {
            // Sign in anonymously if not already signed in
            const userCredential = await auth.signInAnonymously();
            currentUser = userCredential.user;
        }

        if (!currentUser) {
            throw new Error('Failed to sign in anonymously');
        }

        return currentUser.uid;
    } catch (error) {
        console.error('Error signing in anonymously:', error);
        throw error;
    }
};

// Check if the current user is the creator/admin of a room
export const isRoomAdmin = async (
    roomCode: string,
    userId: string,
): Promise<boolean> => {
    try {
        const roomRef = firebase.database().ref(`rooms/${roomCode}`);
        const roomSnapshot = await roomRef.once('value');

        if (!roomSnapshot.exists()) {
            return false;
        }

        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const roomData = roomSnapshot.val();
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return,@typescript-eslint/no-unsafe-member-access
        return roomData.participants[userId]?.isAdmin || false;
    } catch (error) {
        console.error('Error checking admin status:', error);
        return false;
    }
};

// Helper to persist anonymous auth between sessions
export const initializeAuth = async (): Promise<void> => {
    // Firebase will persist the auth state automatically with localStorage
    // This function is mainly to trigger initialization early
    try {
        await auth.signInAnonymously();

        // Set up auth state listener for debugging
        auth.onAuthStateChanged((user) => {
            if (user) {
                console.log('User is signed in anonymously with ID:', user.uid);
            } else {
                console.log('User is signed out');
            }
        });
    } catch (error) {
        console.error('Error initializing auth:', error);
    }
};
